import React from 'react';
import { Hero } from '../components/Hero';
import { LeadSavedShowcase } from '../components/showcase/LeadSavedShowcase';
import { ProblemSection } from '../components/ProblemSection';
import { DatabaseWakeUp } from '../components/DatabaseWakeUp';
import { HowItWorksTeaser } from '../components/HowItWorksTeaser';
import { Proof } from '../components/Proof';
import { Guarantee } from '../components/Guarantee';
import { CtaBand } from '../components/CtaBand';
import { usePageTitle } from '../hooks/usePageTitle';
export function Home() {
  usePageTitle('Viridia Analytics | Every real estate lead answered in under 60 seconds');
  return <>
      <Hero data-id="element-498" data-mp="29i7xjx1s1we0" />
      <LeadSavedShowcase data-id="element-499" data-mp="29ihopnyk69la" />
      <ProblemSection data-id="element-500" data-mp="2di8crjwpabm4" />
      <DatabaseWakeUp data-id="element-501" data-mp="2dii358lnqksc" />
      <HowItWorksTeaser data-id="element-502" data-mp="2dj1o6y6ltpal" />
      <Proof data-id="element-503" data-mp="3kvafowjiyu0a" />
      <Guarantee data-id="element-504" data-mp="3kvk3cdh3kp2t" />
      <CtaBand data-id="element-505" data-mp="3kw22bhv59hef" />
    </>;
}